import { HYDRATE } from 'next-redux-wrapper';
import merge from 'deepmerge';

export const types = {
  // NUEVO V2
  GET_DEVICES: 'DEVICES/GET_DEVICES',
  SET_DEVICES: 'DEVICES/SET_DEVICES',
  SET_PAC_PARAMS: 'DEVICES/SET_PAC_PARAMS',
  SET_DEVICES_STATUS: 'DEVICES/SET_DEVICES_STATUS',
  /* nextjs */
  HYDRATE: 'MAIN/HYDRATE',
};

export const actions = {
  setDevices: (data) => ({
    type: types.SET_DEVICES,
    payload: data,
  }),
  getDevices: (data) => ({
    type: types.GET_DEVICES,
    data,
  }),
  setPacParams: (data) => ({
    type: types.SET_PAC_PARAMS,
    payload: data,
  }),
  setDevicesStatus: (data) => ({
    type: types.SET_DEVICES_STATUS,
    payload: data,
  }),
};

/// /////////////////////////////

const initialState = {
  devices: {
    incluido: [],
    adicional: [],
  },
  pacParams: {
    pageSize: 5,
    category: [],
    minStock: 1,
    query: '',
    sort: 'relevance',
    cl: null,
  },
  status: '',
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { devices } = payload;
      return devices;
    }
    case types.SET_DEVICES: {
      return {
        ...state,
        devices: payload,
      };
    }
    case types.SET_PAC_PARAMS: {
      return {
        ...state,
        pacParams: payload,
      };
    }
    case types.SET_DEVICES_STATUS: {
      return {
        ...state,
        status: payload,
      };
    }
    default:
      return state;
  }
}
export default reducer;
